import React from 'react'
import moment from '../../lib/moment.js'
import { orderBy } from 'lodash'
import contentTemplates from '../metrolendar/content-templates'

function createGridMetrolendarEvents(employee) {
  const events = []
  employee.leaves.forEach(leave => {
    const event = {}
    event.moment = moment(leave.leave_date, "YYYY-MM-DD")
    event.customStyle = {}
    if (leave.leave_status === 'APPROVED') {
      event.label = 'Leave'
      event.customStyle.backgroundColor = '#5c6874'
    } else if (leave.leave_status === 'PENDING' || leave.leave_status === 'PENDING_HR') {
      event.label = 'Pending'
      event.customStyle.color = 'black'
      event.customStyle.backgroundColor = '#FFFBCD'
      event.customStyle.border = '2px solid #E6B50E'
    }
    if (leave.leave_time === 'AM') { event.customStyle.marginRight = '50%' } else if (leave.leave_time === 'PM') { event.customStyle.marginLeft = '50%' }
    events.push(event)
  })
  return events
}

function filterStatus(element) {
  const status = element.status
  return status !== 'CANCEL' && status !== 'REJECTED'
}

function createTableMetrolendarEvents(data, isTeam, findLOBName) {
  /* eslint no-underscore-dangle: 0 */
  let events = []
  if (isTeam) {
    Object.keys(data).forEach(lob => {
      data[lob].forEach(employee => {
        if (employee.leave_requests.length === 0 || employee.leave_requests.filter(filterStatus).length === 0) {
          const event = {}
          event.row = employee._id
          event.row_label = `${employee.first_name} ${employee.last_name} (${employee.nick_name})`
          event.group = findLOBName(lob)
          event.group_label = findLOBName(lob)
          events.push(event)
        } else {
          employee.leave_requests.filter(filterStatus).forEach(leave => {
            for (let i = 0; i < leave.dates.length; i++) {
              const event = {}
              event.row = leave.user_id
              event.row_label = `${employee.first_name} ${employee.last_name} (${employee.nick_name})`
              event.group = findLOBName(lob)
              event.group_label = findLOBName(lob)
              event.moment = moment(leave.dates[i])
              event.leave_type_id = leave.leave_type_id
              event.start_date = moment(leave.start_date)
              event.end_date = moment(leave.end_date)
              event.leave_time = leave.leave_time
              event.days = leave.days
              event.approver_id = leave.approver_id
              event.attachment_url = leave.attachment_url
              event.remark_request_user = leave.remark_request_user
              event.remark_approver = leave.remark_approver
              event.remark_hr = leave.remark_hr
              event.remark_cancel = leave.remark_cancel
              event.status = leave.status
              if (leave.status === 'APPROVED') {
                if (leave.leave_time === 'FULLDAY') { event.content = contentTemplates.circle('#333333') } else if (leave.leave_time === 'AM') { event.content = contentTemplates.halfCircleLeft('#333333') } else if (leave.leave_time === 'PM') { event.content = contentTemplates.halfCircleRight('#333333') }
              } else if (leave.status === 'PENDING' || leave.status === 'PENDING_HR') {
                if (leave.leave_time === 'FULLDAY') { event.content = contentTemplates.ring('#FFD27C') } else if (leave.leave_time === 'AM') { event.content = contentTemplates.halfRingLeft('#FFD27C') } else if (leave.leave_time === 'PM') { event.content = contentTemplates.halfRingRight('#FFD27C') }
              }
              events.push(event)
            }
          })
        }
      })
      events = orderBy(events, 'group', 'asc')
    })
  } else if (data.length === 0) {
    const event = {}
    events.push(event)
  } else {
    data.forEach(leave => {
      for (let i = 0; i < leave.dates.length; i++) {
        const event = {}
        if (leave.status === 'CANCEL' || leave.status === 'REJECTED') {
          event.row = data.user_id
        } else {
          event.row = data.user_id
          event.moment = moment(leave.dates[i])
          event.leave_type_id = leave.leave_type_id
          event.start_date = moment(leave.start_date)
          event.end_date = moment(leave.end_date)
          event.leave_time = leave.leave_time
          event.days = leave.days
          event.approver_id = leave.approver_id
          event.attachment_url = leave.attachment_url
          event.remark_request_user = leave.remark_request_user
          event.remark_approver = leave.remark_approver
          event.remark_hr = leave.remark_hr
          event.remark_cancel = leave.remark_cancel
          event.status = leave.status
          if (leave.status === 'APPROVED') {
            if (leave.leave_time === 'FULLDAY') {
              event.content = contentTemplates.circle('#333333')
            } else if (leave.leave_time === 'AM') {
              event.content = contentTemplates.halfCircleLeft('#333333')
            } else if (leave.leave_time === 'PM') {
              event.content = contentTemplates.halfCircleRight('#333333')
            }
          } else if (leave.status === 'PENDING' || leave.status === 'PENDING_HR') {
            if (leave.leave_time === 'FULLDAY') {
              event.content = contentTemplates.ring('#FFD27C')
            } else if (leave.leave_time === 'AM') {
              event.content = contentTemplates.halfRingLeft('#FFD27C')
            } else if (leave.leave_time === 'PM') {
              event.content = contentTemplates.halfRingRight('#FFD27C')
            }
          }
        }
        events.push(event)
      }
    })
  }
  return events
}
function createCompensateTableMetrolendarEvents(data, isTeam, findLOBName, findFullNameByID) {
  /* eslint no-underscore-dangle: 0 */
  let events = []
  if (isTeam) {
    Object.keys(data).forEach(lob => {
      data[lob].filter(filterStatus).forEach(compensate => {
        for (let i = 0; i < compensate.dates.length; i++) {
          const event = {}
          event.row = compensate.user_id
          event.row_label = findFullNameByID(compensate.user_id)
          event.group = findLOBName(lob)
          event.group_label = findLOBName(lob)
          event.moment = moment(compensate.dates[i])
          event.project_id = compensate.project_id
          event.start_date = moment(compensate.start_date)
          event.end_date = moment(compensate.end_date)
          event.compensate_time = compensate.compensate_time
          event.days = compensate.days
          event.approver_id = compensate.approver_id
          event.remark_request_user = compensate.remark_request_user
          event.remark_approver = compensate.remark_approver
          event.remark_cancel = compensate.remark_cancel
          event.status = compensate.status
          if (compensate.status === 'APPROVED') {
            if (compensate.compensate_time === 'FULLDAY') {
              event.content = contentTemplates.circle('#0071BD')
            } else if (compensate.compensate_time === 'AM') {
              event.content = contentTemplates.halfCircleLeft('#0071BD')
            } else if (compensate.compensate_time === 'PM') {
              event.content = contentTemplates.halfCircleRight('#0071BD')
            }
          } else if (compensate.status === 'PENDING' || compensate.status === 'PENDING_HR') {
            if (compensate.compensate_time === 'FULLDAY') {
              event.content = contentTemplates.ring('#0071BD')
            } else if (compensate.compensate_time === 'AM') {
              event.content = contentTemplates.halfRingLeft('#0071BD')
            } else if (compensate.compensate_time === 'PM') {
              event.content = contentTemplates.halfRingRight('#0071BD')
            }
          }
          events.push(event)
        }
      })
      events = orderBy(events, 'group', 'asc')
    })
  } else if (data.length === 0) {
    const event = {}
    events.push(event)
  } else {
    data.forEach(compensate => {
      for (let i = 0; i < compensate.dates.length; i++) {
        const event = {}
        if (compensate.status === 'CANCEL' || compensate.status === 'REJECTED') {
          event.row = data.user_id
        } else {
          event.row = data.user_id
          event.moment = moment(compensate.dates[i])
          event.project_id = compensate.project_id
          event.start_date = moment(compensate.start_date)
          event.end_date = moment(compensate.end_date)
          event.compensate_time = compensate.compensate_time
          event.days = compensate.days
          event.approver_id = compensate.approver_id
          event.remark_request_user = compensate.remark_request_user
          event.remark_approver = compensate.remark_approver
          event.remark_cancel = compensate.remark_cancel
          event.status = compensate.status
          if (compensate.status === 'APPROVED') {
            if (compensate.compensate_time === 'FULLDAY') {
              event.content = contentTemplates.circle('#0071BD')
            } else if (compensate.compensate_time === 'AM') {
              event.content = contentTemplates.halfCircleLeft('#0071BD')
            } else if (compensate.compensate_time === 'PM') {
              event.content = contentTemplates.halfCircleRight('#0071BD')
            }
          } else if (compensate.status === 'PENDING' || compensate.status === 'PENDING_HR') {
            if (compensate.compensate_time === 'FULLDAY') {
              event.content = contentTemplates.ring('#0071BD')
            } else if (compensate.compensate_time === 'AM') {
              event.content = contentTemplates.halfRingLeft('#0071BD')
            } else if (compensate.compensate_time === 'PM') {
              event.content = contentTemplates.halfRingRight('#0071BD')
            }
          }
        }
        events.push(event)
      }
    })
  }
  return events
}

function createListMetrolendarPublicHoliday(data) {
  const events = []
  data.forEach(holiday => {
    const event = {}
    event.date = moment(holiday.date)
    event.description = holiday.description
    events.push(event)
  })
  return events
}

function createTableMetrolendarSummary(data, isTeam) {
  const summary = {}
  summary.label = "Total Leave Requests"
  summary.default = <div>0</div>

  const counters = {}
  if (isTeam) {
    Object.keys(data).forEach(lob => {
      data[lob].forEach(employee => {
        employee.leave_requests.forEach(leave => {
          leave.dates.forEach(request => {
            let counter = counters[moment(request).format('YYYY-MM-DD')] || 0
            if (leave.status === 'APPROVED' || leave.status === 'PENDING' || leave.status === 'PENDING_HR') {
              if (leave.leave_time === 'FULLDAY') {
                counter += 1
              } else if (leave.leave_time === 'AM' || leave.leave_time === 'PM') {
                counter += 0.5
              }
            }
            counters[moment(request).format('YYYY-MM-DD')] = counter
          }
          )
        })
      })
    })
  }
  summary.map = {}
  Object.keys(counters).forEach(key => {
    summary.map[key] = { content: <div>{counters[key]}</div> }
  })
  return summary
}

export default {
  createGridMetrolendarEvents,
  createTableMetrolendarEvents,
  createTableMetrolendarSummary,
  createListMetrolendarPublicHoliday,
  createCompensateTableMetrolendarEvents,
}



// WEBPACK FOOTER //
// ./src/components/calendar/helper.js